export const CURRENT_PATH = 'CURRENT_PATH'